import { AnswerContent } from '@karakuri-web/faq-type'
import { LogMetaYoutubeDto } from '@karakuri-web/web/api-client'

export function detectYoutube(
  content: AnswerContent
): content is AnswerContent & { meta: LogMetaYoutubeDto } {
  return (content.meta as LogMetaYoutubeDto)?.type === 'video:youtube'
}

// https://developers.google.com/youtube/player_parameters#Parameters
interface Option {
  rel?: '0' | '1'
  origin?: string
}
export function getEmbedUrlForId(id: string | null, options?: Option) {
  if (!id) return ''
  const url = new URL(`https://www.youtube.com/embed/${id}`)
  if (options?.rel) {
    url.searchParams.set('rel', options.rel)
  }
  if (typeof options?.origin !== 'undefined') {
    url.searchParams.set('origin', options?.origin)
  }
  return url.href
}
